// extracted by mini-css-extract-plugin
var _1 = "ForumAppStyle-module__forum-container___Y7XvS";
var _2 = "ForumAppStyle-module__forum-container___Y7XvS";
export { _1 as "forum-container", _2 as "forumContainer" }
